import './scss/vitrine.scss'
import { AreaComprar } from './components/AreaComprar'
import { Counter } from './components/Counter'
import type { ProdutosBlackFridayProps } from '../../types/vitrineApp.props'
import { TitleCtn } from '../../components/TitleCtn'
import { MidiaProdutoVitrine } from '../../components/MidiaProdutoVitrine'
import { getLinkProduto } from '@/utils/getLinkProduto'
import { FavoriteButton } from '@/components/vitrine/components/Favorite-button'

export function ProdutosBlackFriday({
    hostImagem,
    produtos,
    exibeQuantidadeEstoqueVitrine,
    validaEstoqueVitrine,
    exibeValoresSomenteLogado,
    naoExibeNomeDerivacao,
    precoPrincipal,
    tituloVitrine,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine,
    width,
    height,
    vitrineButtonAddToCart
}: Readonly<ProdutosBlackFridayProps>) {
    return (
        <>  
            <TitleCtn tituloVitrine={tituloVitrine} />

            <div className="container">
                <div className="macro-produtos-colunas">
                    {Object.values(produtos).filter(produto => !validaEstoqueVitrine || (produto.qtde_estoque ?? 0) > 0).map((produto, index) => {
                        const aClass = index % 2 === 0 ? 'product-one-of-two' : 'product-two-of-two last'

                        return (
                            <div key={produto.produto_id} className={`product ${aClass}`}>
                                <a href={getLinkProduto(produto)}>
                                    <div className="conteudo-box">
                                        <div className={`img-product ${utilizaFavoritosVitrine ? 'has-favorite-button' : ''}`}>
                                            <MidiaProdutoVitrine
                                                hostImagem={hostImagem}
                                                produto={produto}
                                                width={width}
                                                height={height}
                                                hoverImagensVitrine={hoverImagensVitrine}
                                                hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                            />

                                            {utilizaFavoritosVitrine && <FavoriteButton produto={produto} />}
                                        </div>

                                        <div className="conteudo-product">
                                            <h3 className="name-product">
                                                {produto.titulo || produto.nome}{" "}
                                                {!naoExibeNomeDerivacao && produto.derivacao_nome}
                                            </h3>

                                            <AreaComprar
                                                produto={produto}
                                                precoPrincipal={precoPrincipal}
                                                exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                            />
                                            
                                            {!exibeValoresSomenteLogado && <div className="button button-full button-buy">{vitrineButtonAddToCart}</div>}
                                        </div>
                                    </div>

                                    <Counter
                                        dataFim={produto.data_fim ?? ''}
                                        qtdeEstoque={produto.qtde_estoque}
                                        exibeQuantidadeEstoqueVitrine={Boolean(exibeQuantidadeEstoqueVitrine)}
                                    />
                                </a>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

